module.exports = __webpack_public_path__ + "static/table4-8e3a6c38efc8e6cb83730147a27460f0.jpg";